import { Validator } from '@vista-digital/validator';
import { runInAction } from 'mobx';
import { logger } from '../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { ticketDetailsValidator } from '../../../../utils/validators/ticket-details';
import { getOrderTicketQuantityForShowtime } from '../../selectors/tickets/get-order-ticket-quantity-for-showtime';
import { canTicketBeAddedToOrder } from '../../utils/tickets/can-ticket-be-added-to-order';
import { addOrderTicketForShowtime } from './add-order-ticket-for-showtime';
import { removeOrderTicketsForShowtime } from './remove-order-tickets-for-showtime';
const quantityValidator = Validator.number({ min: 0 });
export const setOrderTicketQuantityForShowtime = (showtimeId, ticket, quantity) => {
    if (!nonEmptyStringValidator(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot set ticket quantity. Provided showtimeId is invalid.');
    }
    if (!ticketDetailsValidator(ticket, logger.error, 'ticket')) {
        throw new Error('Cannot set ticket quantity. Provided ticket details are invalid.');
    }
    if (!quantityValidator(quantity, logger.error, 'quantity')) {
        throw new Error('Cannot set ticket quantity. Provided quantity is invalid.');
    }
    const additionalQuantity = Math.min(quantity - getOrderTicketQuantityForShowtime(showtimeId, ticket), 0);
    if (!canTicketBeAddedToOrder(showtimeId, ticket.ticketTypeId, additionalQuantity)) {
        throw new Error('Cannot set ticket quantity. Requested quantity exceeds order limits.');
    }
    runInAction(() => {
        // Remove existing tickets matching ticket details.
        removeOrderTicketsForShowtime(showtimeId, ticket);
        // Add tickets based on the provided quantity.
        if (quantity > 0)
            addOrderTicketForShowtime(showtimeId, ticket, quantity);
    });
};
